import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white border border-[#E5E0D8] rounded-lg p-10">
        <div className="overline">Caldera View Bar Restaurant · Staff</div>
        <h1 className="mt-3 font-display text-3xl">Sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <Label className="overline" htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-11 border-[#E5E0D8]"
              data-testid="admin-email"
            />
          </div>
          <div>
            <Label className="overline" htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-11 border-[#E5E0D8]"
              data-testid="admin-password"
            />
          </div>
          {error && <div className="text-sm text-[#C0392B]" data-testid="admin-login-error">{error}</div>}
          <Button type="submit" disabled={submitting} className="btn-terracotta w-full h-11 rounded-full" data-testid="admin-login-submit">
            {submitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
